import React, {Component} from 'react';
import {withRouter} from "react-router-dom";
import Row from "@amzn/meridian/row";
import Box from "@amzn/meridian/box";
import Column from "@amzn/meridian/column";
import {connect} from "react-redux";
import Loader from "@amzn/meridian/loader";
import {useDeviceLayout} from "./common/context/DeviceLayoutContext";
import FilterExpander from "./common/FilterExpander";
import DownloadSortPlanButton from "./DownloadSortPlanButton";

class OptionsV2 extends Component {

    render() {
        const {loading, options, isMobile, spacingInset_shorthand2 } = this.props;

        function renderFilterOptions() {
            return (
                options.map(option => {
                            return (
                                <Column heights="fill" alignmentHorizontal="center" spacingInset="none medium none" key={option.name}>
                                    {option.component}
                                </Column>
                            );
                        }
                    )
            )
        }

        function showOptions() {
            if (loading) {
                return (
                    <Column
                        height="100px"
                        alignmentHorizontal="center"
                    >
                        <Loader/>
                    </Column>
                );
            }

            if (isMobile) {
                return (
                    <Box backgroundColor="secondary">
                        <FilterExpander>
                            <Column alignmentHorizontal="left" alignmentVertical="top" spacingInset="medium small">
                                {renderFilterOptions()}
                            </Column>
                        </FilterExpander>
                    </Box>
                )
            }

            return (
                <Row alignmentHorizontal="left" alignmentVertical="top" spacingInset={spacingInset_shorthand2} backgroundColor="secondary">
                    {renderFilterOptions()}
                    <div className='download-sort-plan-button'>
                        <DownloadSortPlanButton/>
                    </div>
                </Row>
            )
        }
        
        return (
            <Column width="100%" className="Options" spacingInset="none">
                {showOptions()}
            </Column>
        );
    }
}

// Adapter to convert class component to functional component.
function classToFunctionAdapter(CustomComponent) {
    return function WrappedComponent(props) {
        const {isMobile, spacingInset_shorthand2} = useDeviceLayout();
        return <CustomComponent {...props} isMobile={isMobile} spacingInset_shorthand2={spacingInset_shorthand2}/>
    }
}

const mapStateToProps = state => ({
    loading: state.optionsReducerV2.loading,
    selectedOptions: state.optionsReducerV2.options,
    showingOptionsMenu: state.optionsReducerV2.showingOptionsMenu,
});
export default withRouter(connect(mapStateToProps)(classToFunctionAdapter(OptionsV2)));


// WEBPACK FOOTER //
// ./src/components/OptionsV2.js